// src/pages/ExercisePage.tsx
// Thin wrapper: guards that a unit is actually loaded before rendering
// ExerciseSession. If someone navigates to /exercise directly with no active
// unit, they're sent back home.

import { Navigate } from 'react-router-dom';
import { useExerciseStore } from '../stores/useExerciseStore';
import ExerciseSession from '../components/exercise/ExerciseSession';

export default function ExercisePage() {
  const currentUnitId = useExerciseStore((s) => s.currentUnitId);

  if (currentUnitId === null) {
    return <Navigate to="/" replace />;
  }

  return <ExerciseSession />;
}